"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Input_1 = __importDefault(require("./Base/Input"));
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const helpers_1 = require("../../lib/helpers");
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const TextInput = (props) => {
    const { children } = props;
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, placeholder: props.placeholder, className: props.className, label: props.label, name: props.name, error: props.error },
        react_1.default.createElement(InputLabel_1.default, null),
        children,
        react_1.default.createElement(Input_1.default, Object.assign({}, helpers_1.without(props, ['className', 'testId']))),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-text-input', TextInput);
